import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { ICategoryResponse } from "../models/Part";

export default function useCategoriesPartial() {
  const { get } = useApiHelper();

  const categories = useQuery({
    queryKey: ["categories", "partial"],
    queryFn: () => get<ICategoryResponse>("/part/categories/partial"),
    staleTime: 1000 * 60 * 10, // 10 minutes
  });

  return { categories };
}
